<script setup lang="ts">
defineOptions({
  name: 'AppLoginAgain',
})

const loadLoginAgain = () => import('@/components/AppAccountForm/login-again.vue')
const LoginAgain = defineAsyncComponent(loadLoginAgain)
const contentReady = ref(false)
const appAccountStore = useAppAccountStore()
const isShow = computed(() => appAccountStore.status === 'unauthenticated' || appAccountStore.isLoginCompleting)

watch(isShow, async (show) => {
  if (show && !contentReady.value) {
    await loadLoginAgain()
    contentReady.value = true
  }
}, { immediate: true })

onMounted(() => {
  void appAccountStore.restoreCurrent()
})
</script>

<template>
  <KLModal
    :model-value="isShow && contentReady"
    :z-index="10000"
    class="wecom-login-modal overflow-hidden max-w-[calc(100vw-2rem)]! w-[820px]!"
    content-class="p-0"
    title="欢迎登录"
    :overlay-blur="true"
    :header="false"
    :footer="false"
    :closable="false"
    :close-on-click-overlay="false"
    :close-on-press-escape="false"
  >
    <LoginAgain v-if="isShow" />
  </KLModal>
</template>

<style>
/* KLModal teleports its root, so the application class must be unscoped. */
.wecom-login-modal[role="dialog"] {
  padding: 0;
  border: 0;
  border-radius: 20px;
}

.wecom-login-modal[role="dialog"][data-state="open"] {
  animation: wecom-login-enter 200ms ease-out both;
}

.wecom-login-modal[role="dialog"][data-state="closed"] {
  animation: wecom-login-leave 200ms ease-in both;
}

@keyframes wecom-login-enter {
  from {
    opacity: 0;
    scale: 0.95;
  }

  to {
    opacity: 1;
    scale: 1;
  }
}

@keyframes wecom-login-leave {
  to {
    opacity: 0;
    scale: 0.95;
  }
}

@media (prefers-reduced-motion: reduce) {
  .wecom-login-modal[role="dialog"][data-state] {
    animation-duration: 1ms;
  }
}
</style>
